import { render, staticRenderFns } from "./Audit-User.vue?vue&type=template&id=5c68813b&scoped=true"
import script from "./Audit-User.js?vue&type=script&lang=js&external"
export * from "./Audit-User.js?vue&type=script&lang=js&external"
import style0 from "./Audit-User.vue?vue&type=style&index=0&id=5c68813b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68813b",
  null
  
)

export default component.exports